<template>
    <div class="new_list">
        <Top></Top>
        <div class="container" style="min-height: 800px;overflow-y: auto">
            <nav class="sub-nav">
                <div class="nav_search">
                    <img src="@/assets/img/sousuo.png" @click="searchClick()">
                    <input type="text" :placeholder="$t('m.news.text[0]')" @keyup="search" v-model="search_text">
                </div>
            </nav>
            <div class="section-container">
                <div class="section-content">
                    <h1>{{ $i18n.locale == 'zh-CN' ? request.catename : request.catename_en }}</h1>
                    <ul class="article-list">
                        <li v-for="(v,k) in articleList" :key="k"
                            @click="changeRoute('/news/detail',{id:v.id,catename:v.catename_en})"
                            class="article-list-item">
                            <span>{{ $i18n.locale == 'zh-CN' ? v.title_ch : v.title_en }}</span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <Bottom></Bottom>
    </div>
</template>

<script>
    import Top from '@/components/top'
    import Bottom from '@/components/bottom'

    export default {
        name: "list",
        components: {
            Top, Bottom
        },
        data() {
            return {
                request: {
                    hot: 1,
                    pageNo: 1,
                    pageSize: 10,
                    catename: "",
                    catename_en: ""
                },
                articleList: [],
                search_text: "",
            }
        },
        created() {
            let account = this.$route.query.mobile ? this.$route.query.mobile : this.$route.query.email;
            let type = this.$route.query.mobile ? 2 : 1;
            let uid = Number(this.$route.query.uid);
            let login = this.$route.query.login;
            if (login) {
                this.doLogin(account, type, uid);
            }
            setTimeout(() => {
                this.request.catename = this.$route.query.catename;
                this.request.catename_en = this.$route.query.catename_en;
                this.getData();
            }, 1000);
        },
        methods: {
            doLogin(account,type,uid) {
                let paramData = this.signRequestLogin({
                  account: account,
                  enum: type,
                  uid: uid,
                  deviceCode: this.deviceCode.code,
                  userAgent: this.deviceCode.userAgent
                });
                paramData.signature = this.signature(paramData);
                this.$axios.post(this.requestConfig.host + "/index/Login/login", paramData).then((res) => {
                    return this.checkResponse(res);
                }).then((res) => {
                    this.aUserInfo(res);
                })
            },
            getData: function () {
                this.request.signature = this.signature(this.request);
                this.$axios.get(this.requestConfig.host + "/index/Article/articleList", {
                    params: this.request
                }).then((res) => {
                    return this.checkResponse(res);
                }).then((res) => {
                    this.articleList = res;
                }).catch((e) => {

                })
            },
            search: function () {
                if (this.search_text != ""){
                    let e=window.event||arguments.callee.caller.arguments[0];
                    if(e.keyCode==13){
                        this.changeRoute('/news/search',{search_text:this.search_text});
                    }
                }
            },
            searchClick() {
                if (this.search_text != ""){
                    this.changeRoute('/news/search',{search_text:this.search_text});
                }
            }
        }
    }
</script>

<style scoped>
    .new_list .container {
        padding: 0;
        width: 90%;
        max-width: 1160px;
        margin: 0 auto 30px;
    }

    .sub-nav {
        margin-bottom: 30px;
        min-height: 50px;
        padding-top: 30px;
        padding-bottom: 15px;
    }

    .nav_search {
        float: right;
        position: relative;
    }

    .nav_search img {
        width: 30px;
        height: 30px;
        cursor: pointer;
        position: absolute;
        z-index: 999;
        left: 10px;
        top: 5px;
    }

    .nav_search input {
        border: 1px solid #ddd;
        border-radius: 30px;
        box-sizing: border-box;
        color: #999;
        width: 300px;
        height: 40px;
        padding-left: 40px;
        padding-right: 20px;
        outline: 0;
    }

    .nav_search input:focus {
        border: 1px solid rgba(53, 124, 225, 1);
    }

    .section-content {
        width: 80%;
        float: right;
    }

    .section-content h1 {
        flex-grow: 1;
        margin-bottom: 10px;
    }

    .article-list-item {
        border-bottom: 1px solid #ddd;
        font-size: 16px;
        padding: 15px 0;
    }
    .article-list-item span {
        cursor: pointer;
    }

    .article-list-item span:hover {
        text-decoration: underline;
    }
</style>
